module.exports = __webpack_public_path__ + "static/media/bcd.51a879fa.svg";